import { Routes, Route } from 'react-router-dom';
import All from '@/pages/all';
import Login from '@/pages/login';
import PeopleByID from '@/pages/people/byid';
import Organization from '@/pages/organization';
import NotFound from '@/pages/404';

export default function MinistryHubRoutes() {
  return (
    <Routes>
      {/* Default to the All view */}
      <Route path='/' element={<All />} />
      {/* Map tab routes to the All view */}
      <Route path='/access' element={<All />} />
      <Route path='/people' element={<All />} />
      <Route path='/people-old' element={<All />} />
      <Route path='/people2' element={<All />} />
      <Route path='/groups' element={<All />} />
      <Route path='/teams' element={<All />} />
      <Route path='/structure' element={<All />} />
      <Route path='/ministries' element={<All />} />
      <Route path='/locations' element={<All />} />
      <Route path='/users' element={<All />} />
      <Route path='/communications' element={<All />} />
      <Route path='/migration' element={<All />} />
      <Route path='/platform' element={<All />} />
      {/* Back-compat: keep /all/* working */}
      <Route path='/all/*' element={<All />} />
      <Route path='/login' element={<Login />} />
      <Route path='/people/:id' element={<PeopleByID />} />
      <Route path='/organization' element={<Organization />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}
